export default "__VITE_ASSET__D1_n0KgZ__"